import { productInteractor } from "~/core";
import colorConfigs from "~/components/product/dict";
import { Decimal } from "decimal.js";
/**
 * 获取下架规格
 * @param {specs} String 下架的规格
 * @returns
 */
function downShelfSpecs(downShelfSpecs) {
  if (downShelfSpecs) {
    return JSON.parse(downShelfSpecs.replace(/\'/g, '"')).flat(1);
  } else {
    return "";
  }
}

/**
 * 产品尺寸规格设置
 * @param {data}
 */
const getSpecsSize = (data, handownShelfSpecs) => {
  const str = data.specsType;
  const specsObject = {};

  if (str && (str.split(",").length > 1 || str != "Color")) {
    let index = 0;
    let specs = data.specsValue.replace(/\'/g, '"');
    let sizes = [];
    const downSpecs = downShelfSpecs(data.downShelfSpecs);

    str.split(",").find((item, i) => {
      if (item != "Color") {
        index = i;
        specsObject.specsType = item;
      }
    });
    specs = JSON.parse(specs)[index];
    if (handownShelfSpecs === false) {
      for (let i = 0; i < specs.length; i++) {
        sizes.push({
          num: "",
          size: specs[i],
          specsValid: downSpecs.includes(specs[i]) ? false : true
        });
      }
    } else {
      for (let i = 0; i < specs.length; i++) {
        if (!downSpecs.includes(specs[i])) {
          sizes.push({ num: "", size: specs[i] });
        }
      }
    }

    specsObject.sizes = sizes;
    specsObject.hasSize = true;
  } else {
    specsObject.num = "";
    specsObject.hasSize = false;
  }

  return specsObject;
};

/**
 * 获取产品详情
 * @param {data}
 */

const getProductDetail = async id => {
  let res = await productInteractor.productDetails(id);
  return res;
};

/**
 * 产品规格颜色设置
 * @param {data}
 */
const getSpecsColor = data => {
  const str = data.specsType;
  const specsObject = {};

  if (str && (str.includes("Color") || str.includes(","))) {
    let index = 0;
    let specs = data.specsValue.replace(/\'/g, '"');
    let colors = [];
    let downSpecs = downShelfSpecs(data.downShelfSpecs);

    if (data.downSpecs) {
      downSpecs = JSON.parse(data.downSpecs.replace(/\'/g, '"')).flat(1);
    }

    str.split(",").find((item, i) => {
      if (item === "Color") {
        index = i;
      }
    });
    specs = JSON.parse(specs)[index];
    specsObject.specsType = str.split(",")[index];

    // 颜色规格数据处理
    for (let i = 0; i < specs.length; i++) {
      if (!downSpecs.includes(specs[i])) {
        const items = data.productSpecs.filter(
          item => item.specsValue1 === specs[i] || item.specsValue2 === specs[i]
        );
        // 取存在规格图的第一条数据，如果都没有图片默认主图
        const _items = items.filter(item => item.imageUrl);

        if (_items.length) {
          colors.push({
            ..._items[0],
            color: specs[i]
          });
        } else {
          colors.push({
            ...items[0],
            color: specs[i],
            imageUrl: data.imgMainUrl
          });
        }
      }
    }

    specsObject.colors = colors;
  } else {
    specsObject.colors = [];
  }
  return specsObject;
};
/**
 * 数据阶梯处理-每个阶梯取最小值
 * @param {arr} 阶梯数组
 * @param {dight} 位数
 * @returns 数量阶梯
 */
const getPriceSteps = (arr, dight) => {
  if (arr.length === 0) {
    return [];
  } else if (arr.length === 1) {
    return arr[0].productPrintingWayPriceSteps;
  } else {
    /**
     * 计算价格阶梯最小值
     * @param {num}
     * @returns 最小值
     */
    function getPrice(num) {
      const prices = [];

      for (let i = 0; i < arr.length; i++) {
        const priceSteps = arr[i].productPrintingWayPriceSteps;
        for (let n = 0; n < priceSteps.length; n++) {
          if (priceSteps[n].num === num) {
            prices.push(priceSteps[n].price);
            break;
          }
        }
      }
      // 字符串转成数字会把最后的0自动去掉, 保留三位如果最后一位是0清空
      let min = Math.min(...prices)?.toFixed(dight, Decimal.ROUND_FLOOR);
      if (dight === 3 && min.charAt(min.length - 1) === "0") {
        min = min.substring(0, min.length - 1);
      }

      return min;
    }

    let steps = arr[0].productPrintingWayPriceSteps;
    steps = steps.map(item => {
      return {
        ...item,
        price: getPrice(item.num)
      };
    });

    steps = steps.sort((a, b) => a["num"] - b["num"]);
    return steps;
  }
};

const convertOrderProductToCartProduct = item => {
  let product = {
    ...item,
    productInfo: {
      nameEn: item.nameEn,
      code: item.productCode
    }

    // productPrice: {
    //   productPrice: item.price,
    // },
  };
  if (product.productPrinting?.printingColors) {
    product.productPrinting.printingColorsList =
      product.productPrinting.printingColors.split(",");
  }
  return product;
};

/**
 * 设置印刷颜色
 * @param {raw}
 */
const setImprintColor = raw => {
  if (raw.label) {
    if (raw.label === "White") {
      return `background: ${raw.value};border: 1px solid #ddd`;
    } else {
      return `background: ${raw.value}`;
    }
  } else {
    return `background-image: radial-gradient(circle at 10% 20%, rgb(222, 168, 248) 0%, rgb(168, 222, 248) 21.8%, rgb(189, 250, 205) 35.6%, rgb(243, 250, 189) 52.9%, rgb(250, 227, 189) 66.8%, rgb(248, 172, 172) 90%, rgb(254, 211, 252) 99.7%);`;
  }
};

const getCurrentColor = colorLabel => {
  return (
    colorConfigs.imprintColors.find(item => item.label === colorLabel) || {}
  );
};

const getImprintLabel = (printingConditionsArr, printingConditions) => {
  if (printingConditionsArr.includes("印刷颜色")) {
    return "Imprint Color";
  } else {
    if (printingConditions?.includes("刺绣")) {
      return "Stiches";
    } else {
      return "Imprint Option";
    }
  }
};

const getImprintLocationsCount = imprintLocations => {
  let imprintLocationsCount = {};
  imprintLocations.forEach(location => {
    let [faceName, ...rest] = location.split("-");
    if (!imprintLocationsCount[faceName]) {
      imprintLocationsCount[faceName] = 1;
    } else {
      imprintLocationsCount[faceName] += 1;
    }
  });
  return imprintLocationsCount;
};

const getImprintLocationName = (imprintLocation, imprintLocationsCount) => {
  if (!imprintLocation) return imprintLocation;
  let [faceName, ...rest] = imprintLocation.split("-");
  if (imprintLocationsCount[faceName] > 1) {
    return imprintLocation;
  } else {
    return faceName;
  }
};
const specImprints = ["Debossed", "Cameo Printing", "Laser Engraved"]; // 凹印（Debossed）、凸印（Cameo Printing）、激光雕刻（Laser Engraved）不需要选择印刷颜色

const getImprintData = (printingColors, pricingMethod, productWay) => {
  let hasImprintColor = false;
  let hasStiches = false;
  let hasBlankOrSample = ["Blank", "Sample"].includes(productWay);
  let pricingMethodDict = pricingMethod.split(",");
  if (printingColors.length > 0) {
    hasImprintColor = true;
    hasStiches = false;
    if (pricingMethod.toLowerCase() === "full-color") {
      hasImprintColor = false;
    }
  } else if (printingConditions?.includes("刺绣")) {
    hasImprintColor = false;
    hasStiches = true;
  } else {
    hasImprintColor = false;
    hasStiches = false;
  }
  return {
    hasImprintColor,
    hasStiches,
    hasBlankOrSample,
    pricingMethodDict
  };
};

const showFullColor = item => {
  const method = item.pricingMethod?.split(",");
  if (method?.length === 1 && method[0].toLowerCase() === "full-color") {
    return true;
  } else {
    return false;
  }
};

export const useProduct = () => {
  return {
    downShelfSpecs,
    getSpecsSize,
    getProductDetail,
    getPriceSteps,
    convertOrderProductToCartProduct,
    getSpecsColor,
    setImprintColor,
    getCurrentColor,
    getImprintLabel,
    getImprintLocationName,
    getImprintLocationsCount,
    getImprintData
  };
};
